import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Badge, Card, Dropdown } from "react-bootstrap";
import PageTitle from "../layouts/PageTitle";
import { useLocation } from "react-router-dom";
import dummmyImg from "../../images/profile/images.jpeg";
import verification1 from "../../images/svg/verified1.svg";
import verification2 from "../../images/svg/verified2.svg";
import FullImage from "../components/Modal/FullImage";
import ReportMessages from "../components/Modal/ReportMessages";
import diamond from "../../images/svg/badgeWithoutBg.svg";
import { FiCopy } from "react-icons/fi";

import {
  activateAccountApi,
  approveRejectRequest,
  blockUser,
  deleteUser,
  deleteUserHard,
  disableUserDevice,
  enableUserDevice,
  forceVerificationApi,
  getUserDetails,
  hideProfileApi,
  recoverAccountApi,
  removeVoiceNoteApi,
  sendNotificationFemale,
  updateImages,
  updateNonPremium,
  updatePremium,
  updateVipPremium,
  updateVipUnlocked,
  uploadImage,
  getSingleUserReports,
  internalUserApi,
  forceIdVerificationApi,
  getIdsUsers,
  updateLeadQuality,
  warningImageApi,
  blockUserApi,
  blockConversationMessageApi,
  lockImage,
  uploadVoice,
  apiFavouriteAllUsers,
  lockImageNotification,
  sendImageRequestFemale,
} from "../../services/UserServices/UserService";
import { notifyError, notifyTopRight } from "../components/Common/Toaster";
import ReasonModal from "../components/Modal/ReasonModal";
import Spinner from "../components/Common/Spinner";
import crossIcon from "../../images/svg/deleteIcon.svg";
import playIcon from "../../images/svg/play-button.svg";
import ReasonForPicDelete from "../components/Modal/ReasonForPicDelete";
import lock from "../../images/svg/lock.svg";
import notification from "../../images/svg/notification.svg";
import unLocked from "../../images/svg/unLocked.svg";
import WarningIconWithTooltip from "../components/WarningIconWithToolTip";
import PremiumUser from "../components/Modal/PremiumUser";
import ConfirmationDeleteAccount from "../components/Modal/ConfirmationDeleteAccount";
import ChangeImageOrderModal from "../components/Modal/ChangeImageOrderModal";
import UserUpdate from "../components/Modal/UserUpdate";
import ConfirmationDeleteAccountHard from "../components/Modal/ConfirmationDeleteAccountHard";
import { useDispatch } from "react-redux";
import { selectConversationNull } from "../../store/actions/SessionActions";
import { FaVolumeUp } from "react-icons/fa";
import ConfirmationEnableUserDevice from "../components/Modal/ConfirmationEnableUserDevice";
import ConfirmationDisableUserDevice from "../components/Modal/ConfirmationDisableUserDevice";
import addPhoto, { addVoice } from "../../services/Auth/AuthService";
import * as htmlToImage from "html-to-image";
import { useSelector } from "react-redux";
import { triggerToggleAction } from "../../store/actions/PostActions";
import ConfirmModalLock from "../components/Modal/ConfirmModalLock";
import ConfirmModalUnlockMessage from "../components/Modal/ConfirmModalUnlockMessage";

export default function UserDetails() {
  const divRef = useRef(null);
  const [searchParams] = useSearchParams();
  const dataId = searchParams.get("data");
  const dispatch = useDispatch();
  const location = useLocation();
  const trigger = useSelector((state) => state.posts.trigger);

  // Mobile detection
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Helper function for mobile dropdown item styling
  const getMobileDropdownItemStyle = (baseStyle = {}) => {
    return {
      ...baseStyle,
      ...(isMobile && {
        padding: "30px",
        fontSize: "30px",
        borderBottom: "1px solid #f0f0f0",
        marginBottom: "0",
      }),
    };
  };
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const voiceInputRef = useRef(null);
  const userIdValue = location?.state?.data ? location?.state?.data : dataId;
  const from = location?.state?.from ? location?.state?.from : "";
  const [userId, setUserId] = useState(userIdValue);
  const imgBaseURl = process.env.REACT_APP_IMAGE_BASEURL;
  const [data, setData] = useState({});
  const [images, setImages] = useState(data?.images || []);
  const [imageForView, setImageForView] = useState("");
  const [view, setView] = useState(false);
  const [loader, setLoader] = useState(false);
  const [reportsByMe, setReportsByMe] = useState([]);
  const [reportedMe, setReportedMe] = useState([]);
  const [showReportMessageModal, setShowReportMessageModal] = useState(false);
  const [currentReportReasons, setCurrentReportReasons] = useState([]);
  const [currentReportDescription, setCurrentReportDescription] = useState("");
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [type, setType] = useState(false);
  const [updatedImages, setUpdatedImages] = useState([]);
  const [showReasonToDeleteImage, setShowReasonToDeleteImage] = useState(false);
  const [premiumUser, setPremiumUser] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showDeleteHardModal, setShowDeleteHardModal] = useState(false);
  const [showDisableUserDeviceModal, setShowDisableUserDeviceModal] =
    useState(false);
  const [showEnableUserDeviceModal, setShowEnableUserDeviceModal] =
    useState(false);
  const [deleteConfirmationId, setDeleteConfirmationId] = useState("");
  const [deleteHardConfirmationId, setDeleteHardConfirmationId] = useState("");
  const [disableUserDeviceId, setDisableUserDeviceId] = useState("");
  const [enableUserDeviceId, setEnableUserDeviceId] = useState("");
  const [changeImageeOrderModal, setChangeImageOrderModal] = useState(false);
  const [userUpdateShow, setUserUpdateShow] = useState(false);
  const [imageType, setImageType] = useState("image");
  const [idsUsers, setIdsUsers] = useState([]);
  const [isFetchingIds, setIsFetchingIds] = useState(false);
  const [hasMoreNextIds, setHasMoreNextIds] = useState(true);
  const [currentPage, setCurrentPage] = useState(
    location?.state?.page ? location?.state?.page : 0,
  );
  const [nextPageNumber, setNextPageNumber] = useState(
    location?.state?.page ? location?.state?.page : 0,
  );
  const [backPageNumber, setBackPageNumber] = useState(
    location?.state?.page ? location?.state?.page : 0,
  );
  const [currentIndex, setCurrentIndex] = useState(0);
  const searchFilter = useSelector((state) => state.filter.filter.search);
  const ageFilter = useSelector((state) => state.filter.filter.age);
  const locationFilter = useSelector((state) => state.filter.filter.location);
  const genderFilter = useSelector((state) => state.filter.filter.gender);
  const statusFilter = useSelector((state) => state.filter.filter.status);
  const dateFilter = useSelector((state) => state.filter.filter.date);
  const formFilledFilter = useSelector(
    (state) => state.filter.filter.formFilled,
  );
  const leadQualityFilter = useSelector(
    (state) => state.filter.filter.leadQuality,
  );
  const typeFilter = useSelector((state) => state.filter.filter.type);
  const activeStatusFilter = useSelector(
    (state) => state.filter.filter.activeStatus,
  );
  const [showConfirm, setShowConfirm] = useState(false);
  const [actionType, setActionType] = useState("");
  const [imageId, setImageId] = useState("");
  const [showActivateAccountConfirm, setShowActivateAccountConfirm] =
    useState(false);
  const [activateAccountConfirmId, setActivateAccountConfirmId] = useState("");
  const [pendingPageChange, setPendingPageChange] = useState(false);
  const [pendingPrevPageChange, setPendingPrevPageChange] = useState(false);
  const [buttonType, setButtonType] = useState("next");
  const [showConfirmNotification, setShowConfirmNotification] = useState(false);
  const isSubAdmin = localStorage.getItem("matchCatchIsSubAdmin") === "true";
  const [dataReport, setDataReport] = useState({});
  const [dataReportId, setDataReportId] = useState("");
  const [copied, setCopied] = useState("");

  const copyText = (text, type) => {
    navigator.clipboard.writeText(text);
    setCopied(type);
    setTimeout(() => setCopied(""), 2000);
  };

  const phone = `${data?.countryCode ? "+" + data?.countryCode : ""} ${data?.phoneNumber}`;

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="12" cy="5" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="19" r="2"></circle>
      </g>
    </svg>
  );

  const handleFetch = async () => {
    setLoader(true);
    try {
      const response = await getUserDetails(userId);
      setData(response.data?.data);
      setImages(response.data?.data?.images);
      setUpdatedImages([]);
      setLoader(false);
    } catch (error) {
      console.log(error, "error");
      setLoader(false);
      notifyError(error.response?.data?.message);
    }
  };

  const fetchReports = async () => {
    try {
      const response = await getSingleUserReports(userId);
      setReportsByMe(response.data.data?.iReported || []);
      setReportedMe(response.data.data?.reportedMe || []);
    } catch (error) {
      console.error("Error fetching reports:", error);
      notifyError(error.response?.data?.message);
    }
  };

  const fetchIdsUsers = async ({ direction, page } = {}) => {
    try {
      setIsFetchingIds(true);

      const dir = direction || buttonType;
      const pageToFetch =
        page ??
        (dir === "next"
          ? nextPageNumber
          : dir === "back"
            ? backPageNumber
            : currentPage);

      const response = await getIdsUsers(
        pageToFetch,
        10,
        searchFilter,
        ageFilter,
        locationFilter,
        genderFilter,
        statusFilter,
        formFilledFilter,
        typeFilter,
        activeStatusFilter,
        dateFilter?.startDate,
        dateFilter?.endDate,
        leadQualityFilter,
      );

      const newIds = response.data.data || [];

      if (dir === "next") {
        setIdsUsers((prev) => [...prev, ...newIds]);
        setNextPageNumber(pageToFetch);
        if (!newIds.length) setHasMoreNextIds(false);
      } else {
        setIdsUsers((prev) => [...newIds, ...prev]);
        setBackPageNumber(pageToFetch);
      }
    } catch (error) {
      console.error("Error fetching ids:", error);
      notifyError(error.response?.data?.message);
    } finally {
      setIsFetchingIds(false);
    }
  };

  useEffect(() => {
    fetchIdsUsers();
  }, [currentPage]);

  useEffect(() => {
    const PREFETCH_THRESHOLD = 5;
    if (!idsUsers.length) return;
    if (!hasMoreNextIds) return;
    if (isFetchingIds) return;

    const remaining = idsUsers.length - 1 - currentIndex;
    if (remaining <= PREFETCH_THRESHOLD) {
      fetchIdsUsers({ direction: "next", page: nextPageNumber + 1 });
    }
  }, [currentIndex, idsUsers.length, hasMoreNextIds, isFetchingIds, nextPageNumber]);

  useEffect(() => {
    if (!idsUsers.length || !userId) return;

    const index = idsUsers.findIndex((item) => item._id === userId);

    if (index !== -1) {
      setCurrentIndex(index);
    }
  }, [idsUsers, userId]);

  useEffect(() => {
    if (!pendingPageChange) return;

    const nextIndex = currentIndex + 1;

    if (idsUsers[nextIndex]) {
      setCurrentIndex(nextIndex);
      setUserId(idsUsers[nextIndex]._id);
      setPendingPageChange(false);
    }
  }, [idsUsers, pendingPageChange]);

  useEffect(() => {
    if (!pendingPrevPageChange) return;

    // Previous page ka last index
    const prevIndex = currentIndex - 1;

    if (idsUsers[prevIndex]) {
      setCurrentIndex(prevIndex);
      setUserId(idsUsers[prevIndex]._id);
      setPendingPrevPageChange(false);
    }
  }, [idsUsers, pendingPrevPageChange]);

  useEffect(() => {
    handleFetch();
    if (!isSubAdmin) {
      fetchReports();
    }
  }, [userId]);

  const handleNext = () => {
    setButtonType("next");
    const nextIndex = currentIndex + 1;
    if (nextIndex < idsUsers.length) {
      setCurrentIndex(nextIndex);
      setUserId(idsUsers[nextIndex]._id);
      return;
    }

    // If we're at the end, request/await next IDs (prefetch may already be in-flight)
    setPendingPageChange(true);

    if (!isFetchingIds) {
      setCurrentPage((prev) => prev + 1);
      setNextPageNumber((prev) => prev + 1);
    }
  };

  const handlePrevious = () => {
    setButtonType("back");
    if (currentIndex > 0) {
      const prevIndex = currentIndex - 1;
      setCurrentIndex(prevIndex);
      setUserId(idsUsers[prevIndex]._id);
      return;
    }

    // currentIndex === 0 → go to previous page
    if (currentIndex === 0 && currentPage > 0 && !isFetchingIds) {
      setPendingPrevPageChange(true);
      setCurrentPage((prev) => prev - 1);
      setBackPageNumber((prev) => prev - 1);
    }
  };

  const onDelete = async () => {
    setLoader(true);
    try {
      const response = await deleteUser(deleteConfirmationId);
      notifyTopRight(response.data?.message);
      handleFetch();
      setLoader(false);
      setShowDeleteModal(false);
      setDeleteConfirmationId("");
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };

  const onDisableUserDevice = async () => {
    setLoader(true);
    try {
      const response = await disableUserDevice(disableUserDeviceId);
      notifyTopRight(response.data?.message);
      handleFetch();
      setLoader(false);
      setShowDisableUserDeviceModal(false);
      setDisableUserDeviceId("");
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };

  const onEnableUserDevice = async () => {
    setLoader(true);
    try {
      const response = await enableUserDevice(enableUserDeviceId);
      notifyTopRight(response.data?.message);
      handleFetch();
      setLoader(false);
      setShowEnableUserDeviceModal(false);
      setEnableUserDeviceId("");
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };

  const onDeleteHard = async () => {
    setLoader(true);
    try {
      const response = await deleteUserHard(deleteHardConfirmationId);
      notifyTopRight(response.data?.message);
      handleFetch();
      setLoader(false);
      setDeleteHardConfirmationId("");
      navigate("/user-management", {
        state: {
          selectedTab: location?.state?.selectedTab,
          page: location?.state?.page,
          search: location?.state?.search,
        },
      });
      setShowDeleteHardModal(false);
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };

  const onAction = async (id) => {
    setLoader(true);
    try {
      const response = await blockUser(id);
      notifyTopRight(response.data?.message);
      handleFetch();

      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };

  const warningImage = async (id) => {
    setLoader(true);
    try {
      const response = await warningImageApi(id);
      notifyTopRight(response.data?.message);
      handleFetch();
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };

  const blockUserMessage = async (id) => {
    setLoader(true);
    try {
      const response = await blockUserApi(id);
      notifyTopRight(response.data?.message);
      handleFetch();
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };

  const blockConversationMessage = async (id) => {
    setLoader(true);
    try {
      const response = await blockConversationMessageApi(id);
      notifyTopRight(response.data?.message);
      handleFetch();
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };

  const onActionHideImageDelete = async (id) => {
    setLoader(true);

    const payload = {
      userId: id,
      images: [],
      reasonsToDeleteImages:
        "Please use a photo which best represents yourself in a luxury setting, or your account may be deactivated. You can stay discreet with a blurred or cropped photo.",
      reasonsToDeleteImages_ch:
        "请使用最能展现您个人风格的照片，否则您的帐户可能会被停用。如需保持低调，可使用模糊或裁剪的照片。",
      reasonsToDeleteImages_zh:
        "請使用最能代表您個人風格的照片，否則帳號可能會被停用。如需保持低調，可使用模糊或裁剪的照片。",
      reasonsToDeleteImages_ms:
        "Sila gunakan gambar yang paling mewakili diri anda secara autentik, atau akaun anda mungkin dinyahaktifkan. Anda boleh kekal privasi dengan gambar yang dikaburkan atau dipotong.",
      reasonsToDeleteImages_id:
        "Gunakan foto yang paling merepresentasikan diri Anda secara autentik, atau akun Anda mungkin akan dinonaktifkan. Anda boleh tetap privat dengan foto buram atau yang dipotong sebagian.",
      reasonsToDeleteImages_vi:
        "Hãy sử dụng ảnh phản ánh đúng bản thân một cách chân thực nhất, nếu không tài khoản của bạn có thể bị vô hiệu. Bạn có thể giữ sự riêng tư bằng ảnh làm mờ hoặc cắt.",
      reasonsToDeleteImages_ko:
        "본인을 가장 잘 표현하는 사진을 사용해 주세요. 그렇지 않으면 계정이 비활성화될 수 있습니다. 흐리거나 잘린 사진도 괜찮습니다.",
      reasonsToDeleteImages_ja:
        "ご自身を最もよく表す写真をご使用ください。そうでない場合、アカウントが停止される可能性があります。ぼかしやトリミングされた写真でも問題ありません。",
      reasonsToDeleteImages_hi:
        "कृपया ऐसी फोटो का उपयोग करें जो आपको सबसे अच्छी तरह से दर्शाती हो, अन्यथा आपका खाता निष्क्रिय किया जा सकता है। आप ब्लर या क्रॉप की गई फोटो से भी गोपनीयता बनाए रख सकते हैं।",
    };

    const payloadForceVarification = {
      userId: id,
    };

    try {
      if (!data?.hideProfile) {
        const res1 = await hideProfileApi(id);
      }
      const res2 = await updateImages(payload);
      if ((data?.verificationImage?.status === "rejected" || !data?.verificationImage?.url) && !data?.faceVerificationRequired) {
        const res3 = await forceVerificationApi(payloadForceVarification);
      }
      const res4 = await warningImageApi(id);
      if (data?.isDeactivated && !data?.isPremium) {
        const res5 = await activateAccountApi(id);
      }

      notifyTopRight("Successfully");
      handleFetch();
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };

  const onApprove = async (id, type) => {
    setLoader(true);
    try {
      const payload = { userId: id, type: type, status: "accepted" };
      const response = await approveRejectRequest(payload);
      handleFetch();
      notifyTopRight(response.data?.message);
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };
  const onPremium = async (id) => {
    setPremiumUser(true);
  };

  const lifeTimeMember = async (id) => {
    setLoader(true);
    try {
      const payload = {
        userId: id,
      };
      await updatePremium(payload);
      notifyTopRight("Successfully");
      handleFetch();
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message || "An error occurred");
      console.error("Error:", error.response || error);
      setLoader(false);
    }
  };

  const vipMember = async (id) => {
    setLoader(true);
    try {
      const payload = {
        userId: id,
      };
      await updateVipPremium(payload);
      notifyTopRight("Successfully");
      handleFetch();
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message || "An error occurred");
      console.error("Error:", error.response || error);
      setLoader(false);
    }
  };

  const vipMemberUnlocked = async (id) => {
    setLoader(true);
    try {
      const payload = {
        userId: id,
      };
      await updateVipUnlocked(payload);
      notifyTopRight("Successfully");
      handleFetch();
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message || "An error occurred");
      console.error("Error:", error.response || error);
      setLoader(false);
    }
  };

  const forceVerification = async (id) => {
    setLoader(true);
    try {
      const payload = {
        userId: id,
      };
      await forceVerificationApi(payload);
      notifyTopRight("Successfully");
      handleFetch();
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message || "An error occurred");
      console.error("Error:", error.response || error);
      setLoader(false);
    }
  };

  const forceIdVerification = async (id) => {
    setLoader(true);
    try {
      const payload = {
        userId: id,
      };
      await forceIdVerificationApi(payload);
      notifyTopRight("Successfully");
      handleFetch();
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message || "An error occurred");
      console.error("Error:", error.response || error);
      setLoader(false);
    }
  };

  const internalUser = async (id) => {
    setLoader(true);
    try {
      const payload = {
        userId: id,
      };
      const response = await internalUserApi(payload);
      notifyTopRight(response.data?.message);
      handleFetch();
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message || "An error occurred");
      console.error("Error:", error.response || error);
      setLoader(false);
    }
  };

  const removeVoiceNote = async (id) => {
    setLoader(true);
    try {
      const payload = {
        userId: id,
      };
      const response = await removeVoiceNoteApi(payload);
      notifyTopRight(response.data?.message);
      handleFetch();
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };

  const sendNotification = async (id, type) => {
    try {
      const response = await sendNotificationFemale(id, type);
      notifyTopRight(response.data?.message);
    } catch (error) {
      notifyError(error.response?.data?.message);
    }
  };

  const sendImageRequest = async (id) => {
    try {
      const response = await sendImageRequestFemale(id);
      notifyTopRight(response.data?.message);
    } catch (error) {
      notifyError(error.response?.data?.message);
    }
  };

  const favouriteAllUsers = async (id) => {
    try {
      const response = await apiFavouriteAllUsers(id);
      notifyTopRight(response.data?.message);
    } catch (error) {
      notifyError(error.response?.data?.message);
    }
  };

  const NonPremium = async (id) => {
    setLoader(true);
    try {
      const response = await updateNonPremium(id);
      notifyTopRight(response.data?.message);
      handleFetch();
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };

  const hideProfile = async (id) => {
    setLoader(true);
    try {
      const response = await hideProfileApi(id);
      notifyTopRight(response.data?.message);
      handleFetch();
    } catch (error) {
      notifyError(error.response?.data?.message);
    }
  };

  const albumName = "verificationImage";

  const handleInputChange = async (e) => {
    const selectedFile = e.target.files[0];

    if (selectedFile) {
      setLoader(true);
      addPhoto(selectedFile, albumName)
        .then(async (response) => {
          const imageName = response?.key;

          if (imageName) {
            const response = await uploadImage({
              imageUrl: imageName,
              userId: data?._id,
            });
            notifyTopRight("Image uploaded successfully");
            handleFetch();
            if (fileInputRef.current) {
              fileInputRef.current.value = "";
            }
          }
        })
        .catch((error) => {
          console.log(error, "image upload error");
          setLoader(false);
          if (fileInputRef.current) {
            fileInputRef.current.value = "";
          }
        });
    }
  };

  const handleVoiceUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const validMimeTypes = ["audio/x-m4a", "audio/mp4"];

    const ext = file.name.split(".").pop().toLowerCase();

    if (!validMimeTypes.includes(file.type) || ext !== "m4a") {
      notifyError("Only M4A audio files are allowed");
      return;
    }

    try {
      setLoader(true);
      const uploadResult = await addVoice(file, "userAudio");
      const response = await uploadVoice({
        voiceNote: uploadResult.key,
        userId: data?._id,
      });
      notifyTopRight("Voice Uploaded Successfully");
      handleFetch();
    } catch (err) {
      console.error(err.message);
      setLoader(false);
    } finally {
      if (voiceInputRef.current) {
        voiceInputRef.current.value = "";
      }
    }
  };

  const downloadScreenshot = () => {
    if (!divRef.current) return;

    htmlToImage
      .toPng(divRef.current, {
        cacheBust: true,
        useCORS: true,
      })
      .then((dataUrl) => {
        const link = document.createElement("a");
        link.href = dataUrl;
        link.download = `screenshot-${Date.now()}.png`;
        link.click();
      })
      .catch((err) => {
        console.error("Error capturing screenshot:", err);
      });
  };

  useEffect(() => {
    if (trigger > 0) {
      downloadScreenshot();

      dispatch(triggerToggleAction(0));
    }
  }, [trigger]);

  const onImageLock = async (id) => {
    setLoader(true);
    try {
      const payload = {
        userId: userId,
        imageId: id,
        isLocked: true,
      };
      const response = await lockImage(payload);
      notifyTopRight(response.data?.message);
      handleFetch();
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };

  const onImageUnLock = async (id) => {
    setLoader(true);
    try {
      const payload = {
        userId: userId,
        imageId: id,
        isLocked: false,
      };
      const response = await lockImage(payload);
      notifyTopRight(response.data?.message);
      handleFetch();
      setLoader(false);
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };

  const handleConfirmNotification = async () => {
    if (!imageId) return;

    setLoader(true);
    try {
      const payload = {
        userId: userId,
        imageId: imageId,
      };
      const response = await lockImageNotification(payload);
      notifyTopRight(response.data?.message);
      setLoader(false);
      setShowConfirmNotification(false);
    } catch (error) {
      notifyError(error.response?.data?.message);
      console.log(error.response, "error");
      setLoader(false);
    }
  };

  const handleConfirm = () => {
    if (!actionType || !imageId) return;

    if (actionType === "lock") {
      onImageLock(imageId);
    }

    if (actionType === "unlock") {
      onImageUnLock(imageId);
    }

    setShowConfirm(false);
    setActionType(null);
  };

  const handleIconClick = (isPrivate, id) => {
    setActionType(isPrivate ? "unlock" : "lock");
    setImageId(id);
    setShowConfirm(true);
  };

  const handleNotificationClick = (id) => {
    setImageId(id);
    setShowConfirmNotification(true);
  };

  /////image with cross icon
  const ImageWithCrossIcon = ({
    image,
    id,
    index,
    isPrivate,
    onRemove,
    type,
    videourl,
  }) => (
    <>
      {type === "video" ? (
        <div className="position-relative">
          {!isSubAdmin && (<img
            src={crossIcon}
            alt="Cross Icon"
            className={`cross-icon pointer  ${image ? "" : "d-none"}`}
            onClick={() => onRemove(index)}
          />)}
          <img
            src={playIcon}
            alt="Cross Icon"
            className={`play-icon pointer ${image ? "" : "d-none"}`}
            onClick={() => {
              if (videourl) {
                setImageForView(imgBaseURl + videourl);
                setView(true);
                setImageType("video");
              }
            }}
            width={40}
            height={40}
          />
          <img
            src={image ? imgBaseURl + image : dummmyImg}
            width={index === 0 ? 177 : 83}
            height={index === 0 ? 177 : 83}
            className="text-center pointer rounded"
            style={{ transition: "width 0.5s, height 0.5s" }}
            onClick={() => {
              if (videourl) {
                setImageForView(imgBaseURl + videourl);
                setView(true);
                setImageType("video");
              }
            }}
            alt="cross icon"
          />
          {id && (
            <img
              src={isPrivate ? lock : unLocked}
              alt="lock"
              style={{
                position: "absolute",
                bottom: "5px",
                right: "5px",
                cursor: "pointer",
              }}
              onClick={() => handleIconClick(isPrivate, id)}
            />
          )}
        </div>
      ) : (
        <div className="position-relative">
          {!isSubAdmin && (<img
            src={crossIcon}
            alt="Cross Icon"
            className={`cross-icon pointer  ${image ? "" : "d-none"}`}
            onClick={() => onRemove(index)}
          />)}
          <img
            src={image ? imgBaseURl + image : dummmyImg}
            width={index === 0 ? 177 : 83}
            height={index === 0 ? 177 : 83}
            className="text-center pointer rounded"
            style={{ transition: "width 0.5s, height 0.5s" }}
            onClick={() => {
              if (image) {
                setImageForView(imgBaseURl + image);
                setView(true);
                setImageType("image");
              }
            }}
            alt="cross icon"
          />
          {id && (
            <img
              src={isPrivate ? lock : unLocked}
              alt="lock"
              style={{
                position: "absolute",
                bottom: "5px",
                right: "5px",
                cursor: "pointer",
              }}
              onClick={() => handleIconClick(isPrivate, id)}
            />
          )}
        </div>
      )}
    </>
  );
  ///function to handle remove image by index
  const handleRemoveImage = (indexToRemove) => {
    setImages((prevImages) =>
      prevImages
        .filter((_, index) => index !== indexToRemove)
        .map((image, index) =>
          index >= indexToRemove ? images[index + 1] : image,
        ),
    );
    setUpdatedImages(images);
  };
  const handleUpdateImages = async () => {
    setShowReasonToDeleteImage(true);
  };

  const activateAccount = async (id) => {
    setLoader(true);
    try {
      const response = await activateAccountApi(id);
      notifyTopRight(response.data?.message);
      handleFetch();
    } catch (error) {
      notifyError(error.response?.data?.message);
    }
  };

  const onActivateAccountClick = (id, isPremium) => {
    if (isPremium && data?.gender === "male") {
      setActivateAccountConfirmId(id);
      setShowActivateAccountConfirm(true);
      return;
    }
    activateAccount(id);
  };

  const onConfirmActivateAccount = async () => {
    if (!activateAccountConfirmId) return;
    await activateAccount(activateAccountConfirmId);
    setShowActivateAccountConfirm(false);
    setActivateAccountConfirmId("");
  };

  const recoveAccount = async (id) => {
    try {
      const response = await recoverAccountApi(id);
      notifyTopRight(response.data?.message);
      handleFetch();
    } catch (error) {
      notifyError(error.response?.data?.message);
    }
  };

  const handleOpenInNewTab = (id) => {
    const url = `/user-details?data=${id}`;
    window.open(url, "_blank");
  };

  const handleOpenSupportTicket = (id) => {
    const url = `/support-requests?data=${id}`;
    window.open(url, "_blank");
  };

  return (
    <div ref={divRef}>
      <PageTitle
        activeMenu="User Details"
        motherMenu="User Management"
        previousPath={
          location?.state?.path ? location?.state?.path : "/user-management"
        }
        stateData={location?.state?.selectedTab}
        stateDataPage={location?.state?.page}
        search={location?.state?.search}
      />
      <ConfirmationDeleteAccount
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onDelete={onDelete}
      />
      <ConfirmationDisableUserDevice
        show={showDisableUserDeviceModal}
        onHide={() => setShowDisableUserDeviceModal(false)}
        onDelete={onDisableUserDevice}
      />
      <ConfirmationEnableUserDevice
        show={showEnableUserDeviceModal}
        onHide={() => setShowEnableUserDeviceModal(false)}
        onDelete={onEnableUserDevice}
      />
      <ConfirmationDeleteAccountHard
        show={showDeleteHardModal}
        onHide={() => setShowDeleteHardModal(false)}
        onDelete={onDeleteHard}
        loader={loader}
      />
      <input
        type="file"
        accept="image/*"
        ref={fileInputRef}
        className="d-none"
        onChange={handleInputChange}
      />
      <input
        ref={voiceInputRef}
        type="file"
        accept="audio/x-m4a,audio/mp4,.m4a"
        hidden
        onChange={handleVoiceUpload}
      />
      <Card>
        {loader ? (
          <Spinner />
        ) : (
          <Card.Header className="d-block align-items-start">
            <div
              className="d-block d-sm-flex justify-content-start"
              style={{ gap: "1rem" }}
            >
              <div>
                <div>
                  <div className="d-flex  gap-2">
                    {[0].map((index) => (
                      <ImageWithCrossIcon
                        key={index}
                        id={images[index]?._id}
                        image={
                          images[index]?.type === "video"
                            ? images[index]?.thumbnailUrl
                            : images[index]?.url
                        }
                        index={index}
                        isPrivate={images[index]?.isLocked}
                        onRemove={handleRemoveImage}
                        type={
                          images[index]?.type === "video" ? "video" : "image"
                        }
                        videourl={
                          images[index]?.type === "video"
                            ? images[index]?.url
                            : ""
                        }
                      />
                    ))}

                    <div className="d-flex flex-column gap-2 justify-content-between">
                      {[1, 2].map((index) => (
                        <ImageWithCrossIcon
                          key={index}
                          id={images[index]?._id}
                          image={
                            images[index]?.type === "video"
                              ? images[index]?.thumbnailUrl
                              : images[index]?.url
                          }
                          index={index}
                          isPrivate={images[index]?.isLocked}
                          onRemove={handleRemoveImage}
                          type={
                            images[index]?.type === "video" ? "video" : "image"
                          }
                          videourl={
                            images[index]?.type === "video"
                              ? images[index]?.url
                              : ""
                          }
                        />
                      ))}
                    </div>
                  </div>
                  <div className="d-flex pt-3 mb-3 gap-2">
                    {[3, 4, 5].map((index) => (
                      <ImageWithCrossIcon
                        key={index}
                        id={images[index]?._id}
                        image={
                          images[index]?.type === "video"
                            ? images[index]?.thumbnailUrl
                            : images[index]?.url
                        }
                        index={index}
                        isPrivate={images[index]?.isLocked}
                        onRemove={handleRemoveImage}
                        type={
                          images[index]?.type === "video" ? "video" : "image"
                        }
                        videourl={
                          images[index]?.type === "video"
                            ? images[index]?.url
                            : ""
                        }
                      />
                    ))}
                  </div>
                </div>
                {!dataId && from === "userList" && (
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <button
                      className="btn btn-primary py-2"
                      onClick={handlePrevious}
                      disabled={currentIndex === 0 && currentPage == 0}
                    >
                      Previous
                    </button>

                    <button
                      className="btn btn-primary py-2"
                      onClick={handleNext}
                    // disabled={isFetchingIds}
                    >
                      Next
                    </button>
                  </div>
                )}
              </div>
              <div className="text-left flex-grow-1">
                <div
                  className="d-flex justify-content-between align-items-center flex-wrap flex-md-nowrap"
                  style={{ minWidth: 0 }}
                >
                  <h3 className="text-color text-wrap text-break">
                    {data?.name}{" "}
                    {data?.isDeletedByAdmin ? (
                      <Badge bg="" className="badge-secondary">
                        Deleted by Admin
                      </Badge>
                    ) : data?.isDeleted ? (
                      <Badge bg="" className="badge-secondary fs-12">
                        Deleted
                      </Badge>
                    ) : data?.isBlocked ? (
                      <Badge bg="" className="badge-danger fs-12">
                        Disabled
                      </Badge>
                    ) : data?.isDeactivated ? (
                      <Badge bg="" className="badge-warning fs-12">
                        Deactivated
                      </Badge>
                    ) : (
                      !data?.isBlocked && (
                        <Badge bg="" className="badge-success fs-12">
                          Enabled
                        </Badge>
                      )
                    )}
                    {(() => {
                      const quality = data?.analyticsFlags?.leadQuality;
                      const leadQualityBadge = {
                        good: { label: "Good", className: "badge-success" },
                        neutral: { label: "Neutral", className: "badge-warning" },
                        bad: { label: "Bad", className: "badge-danger" },
                      }[quality];
                      if (!leadQualityBadge) return null;
                      return (
                        <Badge
                          bg=""
                          className={`${leadQualityBadge.className} fs-12`}
                          style={{ marginLeft: "4px" }}
                        >
                          Lead: {leadQualityBadge.label}
                        </Badge>
                      );
                    })()}
                    {data?.reasonsToDeleteImages && <WarningIconWithTooltip />}
                    {data?.social?.appleId && (
                      <Badge
                        bg=""
                        className="badge-success fs-12"
                        style={{ marginLeft: "2px", backgroundColor: "#000" }}
                      >
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path d="M16.365 1.43c0 1.14-.42 2.09-1.23 2.87-.98.94-2.13 1.49-3.4 1.4-.05-1.1.42-2.14 1.21-2.92.9-.88 2.02-1.43 3.42-1.35M20.8 17.37c-.37.86-.82 1.65-1.35 2.36-.72.93-1.3 1.57-1.77 1.93-.71.57-1.47.86-2.28.88-.58 0-1.28-.17-2.1-.53-.82-.35-1.57-.53-2.23-.53-.7 0-1.47.18-2.31.53-.84.36-1.51.55-1.99.57-.78.03-1.56-.26-2.33-.88-.51-.4-1.12-1.11-1.85-2.12-.79-1.07-1.44-2.31-1.92-3.72-.52-1.57-.78-3.1-.78-4.57 0-1.68.36-3.13 1.09-4.36.57-.98 1.34-1.75 2.31-2.3.97-.56 2.03-.84 3.17-.85.62 0 1.43.2 2.42.6.99.4 1.63.6 1.92.6.21 0 .89-.26 2.05-.78 1.1-.46 2.04-.66 2.82-.6 2.08.17 3.65 1.02 4.69 2.57-1.86 1.12-2.79 2.68-2.79 4.67 0 1.55.58 2.84 1.75 3.87.52.46 1.1.82 1.75 1.08-.14.4-.31.81-.51 1.24z"></path>
                        </svg>
                      </Badge>
                    )}
                    {data?.social?.googleId && (
                      <Badge
                        bg=""
                        className="badge-success fs-12"
                        style={{ marginLeft: "2px", backgroundColor: "#000" }}
                      >
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path
                            d="M21.35 11.1h-9.17v2.98h5.38c-.23 1.24-.93 2.29-1.98 2.98v2.49h3.2c1.88-1.73 2.95-4.28 2.95-7.32 0-.7-.07-1.38-.2-2.05z"
                            fill="#4285F4"
                          />
                          <path
                            d="M12.18 22c2.7 0 4.97-.9 6.63-2.45l-3.2-2.49c-.9.6-2.06.96-3.43.96-2.64 0-4.88-1.78-5.68-4.17H3.18v2.62C4.82 19.98 8.24 22 12.18 22z"
                            fill="#34A853"
                          />
                          <path
                            d="M6.5 13.85c-.2-.6-.32-1.24-.32-1.9s.12-1.3.32-1.9V7.43H3.18A9.81 9.81 0 0 0 2 11.95c0 1.55.37 3.01 1.18 4.52L6.5 13.85z"
                            fill="#FBBC05"
                          />
                          <path
                            d="M12.18 5.86c1.48 0 2.8.51 3.85 1.52l2.87-2.87C17.13 2.75 14.86 2 12.18 2 8.24 2 4.82 4.02 3.18 7.38l3.32 2.62c.8-2.4 3.04-4.14 5.68-4.14z"
                            fill="#EA4335"
                          />
                        </svg>
                      </Badge>
                    )}
                    {data?.social?.facebookId && (
                      <Badge
                        bg=""
                        className="badge-success fs-12"
                        style={{ marginLeft: "2px", backgroundColor: "#000" }}
                      >
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path d="M22 12.07C22 6.48 17.52 2 11.93 2S2 6.48 2 12.07c0 5.02 3.66 9.18 8.44 9.93v-7.03H8.1v-2.9h2.34V9.9c0-2.3 1.36-3.57 3.44-3.57.99 0 2.03.18 2.03.18v2.24h-1.14c-1.13 0-1.48.7-1.48 1.42v1.7h2.52l-.4 2.9h-2.12V22c4.78-.75 8.44-4.9 8.44-9.93z"></path>
                        </svg>
                      </Badge>
                    )}
                    {data?.actualCountry !== data?.location && (
                      <Badge
                        bg=""
                        className="badge-success fs-12"
                        style={{ marginLeft: "2px", backgroundColor: "red" }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="14"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z" />
                        </svg>
                      </Badge>
                    )}
                  </h3>
                  <div
                    className="d-flex align-items-center gap-1 flex-wrap flex-md-nowrap"
                    style={{ minWidth: 0 }}
                  >
                    {data?.isVip && (
                      <Badge bg="" className="badge-success fs-12">
                        Vip
                      </Badge>
                    )}
                    {data?.photoWarningSent && (
                      <Badge bg="" className="badge-success fs-12">
                        Photo Warning Sent
                      </Badge>
                    )}
                    {data?.reportUserMessageSent && (
                      <Badge bg="" className="badge-success fs-12">
                        Report User Message Sent
                      </Badge>
                    )}
                    {data?.blockUserMessageSent && (
                      <Badge bg="" className="badge-success fs-12">
                        Block User Message Sent
                      </Badge>
                    )}
                    {data?.faceVerificationRequired && (
                      <Badge bg="" className="badge-success fs-12">
                        Force Verification
                      </Badge>
                    )}
                    {data?.idVerificationRequired && (
                      <Badge bg="" className="badge-success fs-12">
                        Force ID Verification
                      </Badge>
                    )}
                    {data?.isPremium && data?.gender === "male" && (
                      <div className="bg-circle-diamond">
                        <img src={diamond} alt="diamond" />
                      </div>
                    )}
                    {data?.verificationId?.status === "accepted" && (
                      <div className="bg-circle">
                        <img src={verification1} alt="verification1" />
                      </div>
                    )}
                    {data?.verificationImage?.status === "accepted" && (
                      <div className="bg-circle">
                        <img src={verification2} alt="verification2" />
                      </div>
                    )}
                    {data?.hideProfile && isSubAdmin && (
                      <Badge bg="" className="badge-danger fs-12">
                        Hide
                      </Badge>
                    )}
                    <div>
                      {updatedImages?.length > 0 && (
                        <button
                          type="button"
                          className="btn btn-primary py-2"
                          onClick={handleUpdateImages}
                        >
                          Save
                        </button>
                      )}
                    </div>
                    {data?.isDeleted ? isSubAdmin ? null : (
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="info light"
                          className="light sharp btn btn-info i-false"
                        >
                          {svg1}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item
                            onClick={() => recoveAccount(data?._id)}
                            style={{ marginBottom: "10px" }}
                          >
                            Recover Account
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => {
                              setShowDeleteHardModal(true);
                              setDeleteHardConfirmationId(data._id);
                            }}
                            style={{ marginBottom: "10px" }}
                          >
                            Hard Delete User
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    ) : isSubAdmin ? null : (
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="info light"
                          className="light sharp btn btn-info i-false p-0"
                        >
                          {svg1}
                        </Dropdown.Toggle>
                        <Dropdown.Menu
                          className={
                            isMobile
                              ? "mobile-fullscreen-dropdown"
                              : "overflow-auto"
                          }
                          style={
                            isMobile
                              ? {
                                position: "fixed",
                                top: 0,
                                left: 0,
                                right: 0,
                                bottom: 0,
                                width: "100vw",
                                height: "100vh",
                                zIndex: 9999,
                                backgroundColor: "white",
                                padding: "20px",
                                overflow: "auto",
                                borderRadius: 0,
                              }
                              : { maxHeight: "60vh", zIndex: 1000 }
                          }
                        >
                          {isMobile && (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "20px",
                                borderBottom: "1px solid #eee",
                                paddingBottom: "10px",
                              }}
                            >
                              <h5 style={{ margin: 0 }}>User Actions</h5>
                              <button
                                onClick={() => {
                                  // Close dropdown by clicking outside or using Bootstrap's close method
                                  document.body.click();
                                }}
                                style={{
                                  background: "none",
                                  border: "none",
                                  fontSize: "24px",
                                  cursor: "pointer",
                                  color: "#666",
                                }}
                              >
                                ×
                              </button>
                            </div>
                          )}

                          {/* {data?.isDeactivated && (
                            <Dropdown.Item
                              onClick={() => {
                                activateAccount(data._id);
                              }}
                              style={getMobileDropdownItemStyle({
                                marginBottom: "10px",
                              })}
                            >
                              Activate Account
                            </Dropdown.Item>
                          )} */}
                          <Dropdown.Item
                            onClick={() => setUserUpdateShow(true)}
                            style={getMobileDropdownItemStyle({
                              marginBottom: "10px",
                            })}
                          >
                            Update User
                          </Dropdown.Item>
                          {data?.isPremium && data?.gender === "male" ? (
                            <Dropdown.Item
                              onClick={() => NonPremium(data._id)}
                              style={getMobileDropdownItemStyle({
                                marginBottom: "10px",
                              })}
                            >
                              Non Member
                            </Dropdown.Item>
                          ) : (
                            data?.gender === "male" && (
                              <Dropdown.Item
                                onClick={() => onPremium(data._id)}
                                style={getMobileDropdownItemStyle({
                                  marginBottom: "10px",
                                })}
                              >
                                Member
                              </Dropdown.Item>
                            )
                          )}
                          {!data?.subscription?.isLifetime &&
                            data?.gender === "male" && (
                              <Dropdown.Item
                                onClick={() => lifeTimeMember(data._id)}
                                style={getMobileDropdownItemStyle({
                                  marginBottom: "10px",
                                })}
                              >
                                Lifetime member
                              </Dropdown.Item>
                            )}
                          {data?.gender === "male" && (
                            <Dropdown.Item
                              onClick={() => vipMember(data._id)}
                              style={getMobileDropdownItemStyle({
                                marginBottom: "10px",
                              })}
                            >
                              {data?.isVip ? "Remove VIP" : "VIP Member"}
                            </Dropdown.Item>
                          )}
                          {data?.gender === "male" && (
                            <Dropdown.Item
                              onClick={() => vipMemberUnlocked(data._id)}
                              style={getMobileDropdownItemStyle({
                                marginBottom: "10px",
                              })}
                            >
                              {data?.isVipUnlocked
                                ? "Remove VIP Access"
                                : "VIP Access"}
                            </Dropdown.Item>
                          )}
                          {data?.gender === "male" && (
                            <Dropdown.Item
                              onClick={() => forceVerification(data._id)}
                              style={getMobileDropdownItemStyle({
                                marginBottom: "10px",
                              })}
                            >
                              {data?.faceVerificationRequired
                                ? "Remove Force face verification"
                                : "Force face verification"}
                            </Dropdown.Item>
                          )}

                          <Dropdown.Item
                            onClick={() => forceIdVerification(data._id)}
                            style={getMobileDropdownItemStyle({
                              marginBottom: "10px",
                            })}
                          >
                            {data?.idVerificationRequired
                              ? "Remove Force ID verification"
                              : "Force ID verification"}
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => {
                              setShowDeleteModal(true);
                              setDeleteConfirmationId(data._id);
                            }}
                            style={getMobileDropdownItemStyle({
                              marginBottom: "10px",
                            })}
                          >
                            Delete
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => {
                              setShowDeleteHardModal(true);
                              setDeleteHardConfirmationId(data._id);
                            }}
                            style={getMobileDropdownItemStyle({
                              marginBottom: "10px",
                            })}
                          >
                            Hard Delete User
                          </Dropdown.Item>
                          {data.isBlocked ? (
                            <Dropdown.Item
                              onClick={() => onAction(data._id)}
                              style={getMobileDropdownItemStyle({
                                marginBottom: "10px",
                              })}
                            >
                              Enable
                            </Dropdown.Item>
                          ) : (
                            <Dropdown.Item
                              onClick={() => onAction(data._id)}
                              style={getMobileDropdownItemStyle({
                                marginBottom: "10px",
                                color: "red",
                              })}
                            >
                              Disable
                            </Dropdown.Item>
                          )}
                          {!data.isDeviceBlocked ? (
                            <Dropdown.Item
                              onClick={() => {
                                setShowDisableUserDeviceModal(true);
                                setDisableUserDeviceId(data._id);
                              }}
                              style={getMobileDropdownItemStyle({
                                marginBottom: "10px",
                              })}
                            >
                              Disable User Device
                            </Dropdown.Item>
                          ) : (
                            <Dropdown.Item
                              onClick={() => {
                                setShowEnableUserDeviceModal(true);
                                setEnableUserDeviceId(data._id);
                              }}
                              style={getMobileDropdownItemStyle({
                                marginBottom: "10px",
                              })}
                            >
                              Enable User Device
                            </Dropdown.Item>
                          )}
                          {/* {data?.gender === "male" && (
                            <Dropdown.Item
                              onClick={() => onActionHideImageDelete(data._id)}
                              style={getMobileDropdownItemStyle({
                                marginBottom: "10px",
                              })}
                            >
                              Hide profile with delete images
                            </Dropdown.Item>
                          )} */}
                          {!data?.photoWarningSent && (
                            <Dropdown.Item
                              onClick={() => warningImage(data._id)}
                              style={getMobileDropdownItemStyle({
                                marginBottom: "10px",
                              })}
                            >
                              Warning Image Message
                            </Dropdown.Item>
                          )}
                          {data.isBlocked && (
                            <>
                              {!data?.reportUserMessageSent && (
                                <Dropdown.Item
                                  onClick={() => blockUserMessage(data._id)}
                                  style={getMobileDropdownItemStyle({
                                    marginBottom: "10px",
                                  })}
                                >
                                  Block User Message (Reported)
                                </Dropdown.Item>
                              )}
                              {!data?.blockUserMessageSent && (
                                <Dropdown.Item
                                  onClick={() =>
                                    blockConversationMessage(data._id)
                                  }
                                  style={getMobileDropdownItemStyle({
                                    marginBottom: "10px",
                                  })}
                                >
                                  Block Conversation Message
                                </Dropdown.Item>
                              )}
                            </>
                          )}
                        </Dropdown.Menu>
                      </Dropdown>
                    )}
                  </div>
                </div>

                <div className="d-block d-md-flex gap-5">
                  <div>
                    <p>
                      Gender - <b>{data?.gender}</b>
                    </p>
                    <p>
                      Age - <b>{data?.age}</b>
                    </p>
                    <p>
                      Height - <b>{data?.height?.name}</b>
                    </p>
                    <p>
                      Income - <b>{data?.income?.name}</b>
                    </p>
                    <p>
                      Languages -{" "}
                      <b>
                        {data?.languages
                          ?.map((language) => language.name)
                          .join(", ")}
                      </b>
                    </p>
                    <p>
                      Created At -{" "}
                      <b>
                        {data?.createdAt &&
                          moment(data?.createdAt).format("MMM Do YYYY, h:mm a")}
                      </b>
                    </p>
                    <p>
                      Completed At -{" "}
                      <b>
                        {data?.completedAt &&
                          moment(data?.completedAt).format(
                            "MMM Do YYYY, h:mm a",
                          )}
                      </b>
                    </p>
                    <p>
                      Reported Count - <b>{reportedMe?.length}</b>
                    </p>
                    <p>
                      Actual Location - <b>{data?.actualCountry}</b>
                    </p>
                    {data?.gender === "male" && (
                      <p>
                        Member -{" "}
                        <b>
                          {data?.isPremium
                            ? "yes"
                            : data?.subscription?.subscriptionPeriod
                              ? "Past Member"
                              : "No"}
                        </b>
                      </p>
                    )}
                    <p className="pointer">
                      User Id - <b>{data?._id}</b>
                    </p>
                    {(data?.isPremium ||
                      data?.subscription?.subscriptionPeriod) &&
                      data?.gender === "male" && (
                        <p>
                          Duration -{" "}
                          <b>
                            {data?.subscription?.isLifetime
                              ? "Lifetime"
                              : data?.subscription?.subscriptionPeriod}
                          </b>
                        </p>
                      )}
                  </div>
                  <div className="">
                    <p>
                      Email - <b>{data?.email}</b>
                    </p>

                    <p>
                      Phone Number -{" "}
                      <b>
                        {data?.countryCode && "+" + data?.countryCode}{" "}
                        {data?.phoneNumber}
                      </b>
                    </p>
                    <p>
                      Body Type -{" "}
                      <b>
                        {data?.bodyType?.name === "Full Figure" &&
                          data?.gender === "male"
                          ? "Average"
                          : data?.bodyType?.name}
                      </b>
                    </p>
                    {/* <p>
                      Net Worth - <b>{data?.netWorth?.name}</b>
                    </p> */}
                    <p>
                      Device type -{" "}
                      <b>
                        {data?.deviceType ? data?.deviceType.toUpperCase() : ""}
                      </b>
                    </p>
                    <p>
                      Last Active -{" "}
                      <b>
                        {data?.lastApiCall &&
                          moment
                            .unix(data?.lastApiCall)
                            .format("MMM Do YYYY, h:mm a")}
                      </b>
                    </p>
                    <p>
                      conversation Count - <b>{data?.conversationCount}</b>
                    </p>
                    <p>
                      Last Login -{" "}
                      <b>
                        {data?.loginDetail?.isActive &&
                          moment(data?.loginDetail?.createdAt).format(
                            "MMM Do YYYY, h:mm a",
                          )}
                      </b>
                    </p>
                    <p
                      onClick={() => handleOpenSupportTicket(data?._id)}
                      className="pointer"
                    >
                      Support Ticket - <b>{data?.supportTicket}</b>
                    </p>
                    <p>
                      Location - <b>{data?.location}</b>
                    </p>
                    {(data?.isPremium ||
                      data?.subscription?.subscriptionPeriod) &&
                      data?.gender === "male" && (
                        <p>
                          Start Time -{" "}
                          <b>
                            {" "}
                            {data?.subscription?.purchaseDate &&
                              moment
                                .unix(data?.subscription.purchaseDate)
                                .format("MMM Do YYYY, h:mm a")}
                          </b>
                        </p>
                      )}
                    {(data?.isPremium ||
                      data?.subscription?.subscriptionPeriod) &&
                      data?.gender === "male" && (
                        <p>
                          End Time -{" "}
                          <b>
                            {" "}
                            {data?.subscription?.expireDate &&
                              moment
                                .unix(data?.subscription.expireDate)
                                .format("MMM Do YYYY, h:mm a")}
                          </b>
                        </p>
                      )}
                  </div>
                </div>
                {data?.voiceNote && (
                  <Badge
                    bg=""
                    className="
      badge-success fs-12 
      d-flex flex-column flex-sm-row 
      align-items-center justify-content-between gap-2
    "
                    style={{
                      whiteSpace: "normal",
                      width: "100%",
                      maxWidth: "400px",
                      marginTop: "25px",
                    }}
                  >
                    {/* icon + label */}
                    <div className="d-flex align-items-center gap-2">
                      <FaVolumeUp size={14} />
                      <span>Voice Note</span>
                    </div>

                    {/* audio player */}
                    <audio
                      controls
                      src={imgBaseURl + data?.voiceNote}
                      className="w-100 w-sm-auto mt-2 mt-sm-0"
                      style={{ height: "28px", maxWidth: "250px" }}
                    >
                      Your browser does not support the audio element.
                    </audio>
                  </Badge>
                )}
              </div>
            </div>
          </Card.Header>
        )}
      </Card>
      {data?.verificationImage?.url && (
        <Card>
          {loader ? (
            <Spinner />
          ) : (
            <Card.Header className="d-block align-items-start">
              <div className="d-flex justify-content-between">
                <Card.Title>Verification Image</Card.Title>
                <div className="d-flex justify-content-between align-items-center gap-1">
                  {data?.gender === "male" ? (
                    data?.verificationImage?.isUploadAgain &&
                      data?.verificationImage?.adminAction === "pending" ? (
                      <Badge bg="" className="badge-warning">
                        Again Uploaded
                      </Badge>
                    ) : data?.verificationImage?.status === "pending" ? (
                      <Badge bg="" className="badge-warning">
                        Pending
                      </Badge>
                    ) : data?.verificationImage?.status === "accepted" &&
                      data?.verificationImage?.adminAction === "pending" ? (
                      <Badge bg="" className="badge-warning">
                        Auto Approved
                      </Badge>
                    ) : data?.verificationImage?.status === "accepted" &&
                      data?.verificationImage?.adminAction === "accepted" ? (
                      <Badge bg="" className="badge-success">
                        Approved
                      </Badge>
                    ) : (
                      <Badge bg="" className="badge-danger">
                        Rejected
                      </Badge>
                    )
                  ) : data?.gender === "female" ? (
                    data?.verificationImage?.isUploadAgain &&
                      data?.verificationImage?.adminAction === "pending" ? (
                      <Badge bg="" className="badge-warning">
                        Again Uploaded
                      </Badge>
                    ) : data?.verificationImage?.status === "pending" ? (
                      <Badge bg="" className="badge-warning">
                        Pending
                      </Badge>
                    ) : data?.verificationImage?.status === "accepted" &&
                      data?.verificationImage?.adminAction === "pending" ? (
                      <Badge bg="" className="badge-warning">
                        Auto Approved
                      </Badge>
                    ) : data?.verificationImage?.status === "accepted" &&
                      data?.verificationImage?.adminAction === "accepted" ? (
                      <Badge bg="" className="badge-success">
                        Approved
                      </Badge>
                    ) : (
                      <Badge bg="" className="badge-danger">
                        Rejected
                      </Badge>
                    )
                  ) : (
                    ""
                  )}

                  {isSubAdmin ? null : (<Dropdown>
                    <Dropdown.Toggle
                      variant="info light"
                      className="light sharp btn btn-info i-false p-0"
                    >
                      {svg1}
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ zIndex: 1000 }}>
                      {data?.verificationImage?.adminAction === "pending" ? (
                        <>
                          <Dropdown.Item
                            onClick={() => onApprove(data._id, "image")}
                          >
                            Approve
                          </Dropdown.Item>

                          <Dropdown.Item
                            onClick={() => {
                              setShowRejectModal(true);
                              setType("image");
                            }}
                          >
                            Reject
                          </Dropdown.Item>
                        </>
                      ) : data?.verificationImage?.adminAction ===
                        "accepted" ? (
                        <Dropdown.Item
                          onClick={() => {
                            setShowRejectModal(true);
                            setType("image");
                          }}
                        >
                          Reject
                        </Dropdown.Item>
                      ) : (
                        <Dropdown.Item
                          onClick={() => onApprove(data._id, "image")}
                        >
                          Approve
                        </Dropdown.Item>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>)}
                </div>
              </div>

              <div
                className="d-block d-sm-flex justify-content-start mt-3"
                style={{ gap: "1rem" }}
              >
                <div>
                  <img
                    src={
                      data?.verificationImage?.url
                        ? imgBaseURl + data?.verificationImage?.url
                        : dummmyImg
                    }
                    width={150}
                    height={150}
                    className="rounded pointer"
                    onClick={() => {
                      setImageForView(
                        imgBaseURl + data?.verificationImage?.url,
                      );
                      setView(true);
                      setImageType("image");
                    }}
                    alt="verificationImage"
                  />
                </div>
              </div>
            </Card.Header>
          )}
        </Card>
      )}
      {data?.verificationId && (
        <Card>
          {loader ? (
            <Spinner />
          ) : (
            <Card.Header className="d-block align-items-start">
              <div className="d-flex justify-content-between">
                <Card.Title>Verification Id</Card.Title>
                <div className="d-flex justify-content-between align-items-center gap-1">
                  {data?.verificationId?.status === "accepted" ? (
                    <Badge bg="" className="badge-success">
                      Verified
                    </Badge>
                  ) : data?.verificationId?.status === "rejected" ? (
                    <Badge bg="" className="badge-danger">
                      Rejected
                    </Badge>
                  ) : (
                    <Badge bg="" className="badge-warning">
                      Pending
                    </Badge>
                  )}
                  {!isSubAdmin && (<Dropdown>
                    <Dropdown.Toggle
                      variant="info light"
                      className="light sharp btn btn-info i-false p-0"
                    >
                      {svg1}
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ zIndex: 1000 }}>
                      {data?.verificationId?.status === "pending" ? (
                        <>
                          <Dropdown.Item
                            onClick={() => onApprove(data._id, "id")}
                          >
                            Approve
                          </Dropdown.Item>

                          <Dropdown.Item
                            onClick={() => {
                              setShowRejectModal(true);
                              setType("id");
                            }}
                          >
                            Reject
                          </Dropdown.Item>
                        </>
                      ) : data?.verificationId?.status === "accepted" ? (
                        <Dropdown.Item
                          onClick={() => {
                            setShowRejectModal(true);
                            setType("id");
                          }}
                        >
                          Reject
                        </Dropdown.Item>
                      ) : (
                        <Dropdown.Item
                          onClick={() => onApprove(data._id, "id")}
                        >
                          Approve
                        </Dropdown.Item>
                      )}
                    </Dropdown.Menu>
                  </Dropdown>)}
                </div>
              </div>
              <div className="mt-2">
                <p>
                  <b>Document Type :</b> {data?.verificationId?.documentType}
                </p>
              </div>
              <div
                className="d-block d-sm-flex justify-content-start mt-3"
                style={{ gap: "1rem" }}
              >
                <div className="d-flex gap-3">
                  <img
                    src={
                      data?.verificationId?.frontUrl
                        ? imgBaseURl + data?.verificationId?.frontUrl
                        : dummmyImg
                    }
                    width={150}
                    height={150}
                    className="rounded pointer"
                    onClick={() => {
                      setImageForView(
                        imgBaseURl + data?.verificationId?.frontUrl,
                      );
                      setView(true);
                      setImageType("image");
                    }}
                    alt="verificationId"
                  />
                  <img
                    src={
                      data?.verificationId?.backUrl
                        ? imgBaseURl + data?.verificationId?.backUrl
                        : dummmyImg
                    }
                    width={150}
                    height={150}
                    className="rounded pointer"
                    onClick={() => {
                      setImageForView(
                        imgBaseURl + data?.verificationId?.backUrl,
                      );
                      setView(true);
                      setImageType("image");
                    }}
                    alt="verificationId"
                  />
                </div>
              </div>
            </Card.Header>
          )}
        </Card>
      )}
      <div className="row">
        {reportedMe.length > 0 && (
          <div className="col-xl-6 col-xxl-6 col-sm-6">
            <Card>
              <Card.Header>
                <Card.Title>Reported {data?.name}</Card.Title>
              </Card.Header>
              <Card.Body>
                {reportedMe.length > 0 ? (
                  reportedMe.map((report, index) => (
                    <div key={index} className="mb-3">
                      <div className="d-flex justify-content-between align-items-start gap-2">
                        <div className="pointer" style={{ flexBasis: "95%" }}>
                          <p
                            className="pointer py-1"
                            style={{ color: "#3c3413ff" }}
                            onClick={() => handleOpenInNewTab(report.user?._id)}
                          >
                            Reported By: {report.user?.name}
                          </p>
                          <p
                            className="pointer py-1"
                            style={{ color: "#007bff" }}
                            onClick={() => {
                              setCurrentReportReasons(report?.reason);
                              setCurrentReportDescription(report?.description);
                              setShowReportMessageModal(true);
                            }}
                          >
                            Reason: Report Messages
                          </p>
                          <p>
                            Date:{" "}
                            {moment(report.timestamp).format(
                              "MMM Do YYYY, h:mm a",
                            )}
                          </p>
                          <hr />
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No reports against this user.</p>
                )}
              </Card.Body>
            </Card>
          </div>
        )}
        {reportsByMe.length > 0 && (
          <div className="col-xl-6 col-xxl-6 col-sm-6">
            <Card>
              <Card.Header className="d-block align-items-start">
                <div className="d-flex justify-content-between">
                  <Card.Title>Reports By {data?.name}</Card.Title>
                </div>
              </Card.Header>
              <Card.Body>
                {reportsByMe.length > 0 ? (
                  reportsByMe.map((report, index) => (
                    <div key={index} className="mb-3">
                      <div className="d-flex justify-content-between align-items-start gap-2">
                        <div className="pointer" style={{ flexBasis: "95%" }}>
                          <p
                            className="pointer py-1"
                            style={{ color: "#3c3413ff" }}
                            onClick={() => handleOpenInNewTab(report.user?._id)}
                          >
                            Reported To: {report.user?.name}
                          </p>
                          <p
                            className="pointer py-1"
                            style={{ color: "#007bff" }}
                            onClick={() => {
                              setCurrentReportReasons(report?.report?.reason);
                              setCurrentReportDescription(report?.report?.description);
                              setShowReportMessageModal(true);
                              setDataReport(report.report);
                              setDataReportId(report.reportId);
                            }}
                          >
                            Reason: Report Messages
                          </p>
                          <p>
                            Date:{" "}
                            {moment(report.timestamp).format(
                              "MMM Do YYYY, h:mm a",
                            )}
                          </p>
                          <hr />
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No reports made by this user.</p>
                )}
              </Card.Body>
            </Card>
          </div>
        )}
      </div>
      {showRejectModal && (
        <ReasonModal
          show={showRejectModal}
          id={userId}
          type={type}
          table={handleFetch}
          onHide={() => setShowRejectModal(false)}
        />
      )}
      {view && (
        <FullImage
          show={view}
          image={imageForView}
          onHide={() => setView(false)}
          imageType={imageType}
        />
      )}
      {changeImageeOrderModal && (
        <ChangeImageOrderModal
          show={changeImageeOrderModal}
          id={userId}
          images={images}
          table={handleFetch}
          onHide={() => setChangeImageOrderModal(false)}
        />
      )}
      {showReasonToDeleteImage && (
        <ReasonForPicDelete
          show={showReasonToDeleteImage}
          id={userId}
          deleteImages={(data?.images || []).filter(
            (orig) => !images.some((img) => img._id === orig._id)
          )}
          table={handleFetch}
          onHide={() => setShowReasonToDeleteImage(false)}
        />
      )}
      {premiumUser && (
        <PremiumUser
          show={premiumUser}
          id={userId}
          table={handleFetch}
          setLoader={setLoader}
          onHide={() => setPremiumUser(false)}
        />
      )}
      {userUpdateShow && (
        <UserUpdate
          show={userUpdateShow}
          onHide={() => setUserUpdateShow(false)}
          table={handleFetch}
          user={data}
        />
      )}
      {showReportMessageModal && (
        <ReportMessages
          show={showReportMessageModal}
          text={currentReportDescription}
          data={currentReportReasons}
          onHide={() => setShowReportMessageModal(false)}
        />
      )}
      {showConfirm && (
        <ConfirmModalLock
          open={showConfirm}
          title={actionType === "lock" ? "Lock Image" : "Unlock Image"}
          description={
            actionType === "lock"
              ? "Are you sure you want to lock this image? Users won’t be able to view it."
              : "Are you sure you want to unlock this image?"
          }
          onCancel={() => setShowConfirm(false)}
          onConfirm={handleConfirm}
        />
      )}
      {showConfirmNotification && (
        <ConfirmModalUnlockMessage
          loading={loader}
          open={showConfirmNotification}
          title={"Allow Access to Photos and Videos"}
          description={"Please allow access to your photos and video"}
          onCancel={() => setShowConfirmNotification(false)}
          onConfirm={handleConfirmNotification}
        />
      )}
    </div>
  );
}
